import { OnboardingSessionContextValue } from './types';
import { createContext } from 'react';

export const OnboardingSessionContext = createContext<OnboardingSessionContextValue | null>(null);